import { faDownLeftAndUpRightToCenter } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { Button, ButtonSizes } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Colors, pxToRem } from '@b-stock/fe-core/design-system'

const Header = styled.header`
  align-items: center;
  background-color: ${Colors.Semantic.Neutral.light_grey};
  border-bottom: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem;
`

const Title = styled.h2`
  color: black;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.375rem;
  letter-spacing: 0.09rem;
  margin: 0;
  text-transform: uppercase;
`

// Small screens keep the icon and drop the label; `title` still names it.
const Label = styled.span`
  @media ${Breakpoints.max.small} {
    display: none;
  }
`

const ExitButton = ({
  label,
  onClick,
}: {
  label?: string
  onClick: () => void
}) => {
  const { formatMessage } = useIntl()
  const text = label ?? formatMessage({ id: 'Common.exitFullScreen' })

  return (
    <Button
      appearance="primary"
      onClick={onClick}
      size={ButtonSizes.small}
      title={text}
      type="button"
    >
      <FontAwesomeIcon icon={faDownLeftAndUpRightToCenter} size="sm" />
      <Label>{text}</Label>
    </Button>
  )
}

// The scrolling column between Header and Footer.
const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`

const Footer = styled.footer`
  align-items: center;
  background-color: ${Colors.Semantic.Neutral.light_grey};
  border-top: ${pxToRem(1)} solid ${Colors.Semantic.Neutral.medium_grey};
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
  padding: ${pxToRem(11)} 1rem;
`

export const Fullscreen = { Body, ExitButton, Footer, Header, Title }
